import { render, staticRenderFns } from "./otherSqms.vue?vue&type=template&id=1476c65d"
import script from "./otherSqms.vue?vue&type=script&lang=js"
export * from "./otherSqms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1476c65d')) {
      api.createRecord('1476c65d', component.options)
    } else {
      api.reload('1476c65d', component.options)
    }
    module.hot.accept("./otherSqms.vue?vue&type=template&id=1476c65d", function () {
      api.rerender('1476c65d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/otherSqms.vue"
export default component.exports